import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import { Star, Quote } from 'lucide-react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination } from 'swiper/modules'
import { reviews } from '../../data/siteData'
import 'swiper/css'
import 'swiper/css/pagination'

export default function Reviews() {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <section id="reviews" className="relative py-24 sm:py-32 bg-section-dark grain-overlay" style={{ backgroundColor: 'rgba(10,14,10,0.55)', backdropFilter: 'blur(2px)' }}>
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-military/40 to-transparent" />

      <div ref={ref} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <span className="font-mono text-xs text-military-light tracking-[0.4em] uppercase">
            Opinie
          </span>
          <h2 className="font-display text-5xl sm:text-6xl md:text-7xl text-bone mt-4 tracking-wider">
            CO MÓWIĄ NASI KLIENCI
          </h2>
          <p className="font-body text-chrome mt-4 max-w-2xl mx-auto">
            Niech oni powiedzą za nas.
          </p>
          <div className="w-24 h-0.5 bg-military-light mx-auto mt-6" />
        </motion.div>

        {/* Reviews Carousel */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={24}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            loop
            className="pb-14"
          >
            {reviews.map((review, i) => (
              <SwiperSlide key={i}>
                <div className="h-full p-6 bg-steel border-l-2 border-amber/60 rounded-sm relative">
                  {/* Quote decoration */}
                  <Quote size={40} className="absolute top-4 right-4 text-military/10" />

                  {/* Stars */}
                  <div className="flex gap-1 mb-4">
                    {Array.from({ length: review.rating }).map((_, si) => (
                      <Star key={si} size={16} className="text-amber fill-amber" />
                    ))}
                  </div>

                  {/* Text */}
                  <p className="font-body text-sm text-chrome-light leading-relaxed mb-6 italic">
                    &ldquo;{review.text}&rdquo;
                  </p>

                  {/* Author */}
                  <div className="mt-auto">
                    <p className="font-subheading font-bold text-bone">
                      — {review.name}
                    </p>
                    <p className="font-mono text-xs text-chrome">
                      {review.location}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </section>
  )
}
